<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="3"
      width="13"
      height="10"
      rx="2"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <line
      x1="6"
      y1="3.5"
      x2="6"
      y2="12.5"
      stroke="currentColor"
      stroke-width="1.5"
    />
  </svg>
</template>
